<template>
  <v-app class="App">
    <transition-page>
      <router-view />
    </transition-page>
  </v-app>
</template>

<script>
import TransitionPage from "./components/TransitionPage";
export default {
  name: "App",
  components: {
    TransitionPage
  }
};
</script>
<style>
.app-content .v-content__wrap > :first-child {
  min-height: calc(100vh - 64px);
}

.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.rounded-custom {
  border-radius: 20px !important;
  overflow: hidden;
}
</style>
